import { MutableRefObject, useEffect, useState } from 'react'
import useIsMountedRef from 'use-is-mounted-ref'
import get from 'get-value'
import { getConfig } from '../API/GenericConfigAPI'
import { ReactState } from '../Contexts'
import { JSONResponse } from '../../../NonReact/common/Types/Types'

export type JSONEndTypes = string | boolean | number | object

export function useConfig<T extends JSONEndTypes>(fileName: string, key: string, defaultValue: T): T
export function useConfig<T extends JSONEndTypes>(fileName: string, key: string, defaultValue?: undefined): Nullable<T>
export function useConfig<T extends JSONEndTypes>(fileName: string, key: string, defaultValue?: T): Nullable<T> {
    const [config, setConfig]: ReactState<Nullable<T>> = useState<Nullable<T>>(defaultValue ?? null)

    const isMounted: MutableRefObject<boolean> = useIsMountedRef()

    useEffect((): void => {
        getConfig<object>(fileName)
            .then((response: JSONResponse<object>): void => {
                if (isMounted.current) {
                    setConfig((get(response ?? {}, key) as Nullable<T>) ?? defaultValue ?? null)
                }
            })
            .catch((): void => {
                if (isMounted.current) {
                    setConfig(defaultValue ?? null)
                }
            })
    }, [fileName, key])

    return config
}
